import { useEffect } from 'react';
import { useOverlayContext } from '../OverlayContext';
export function FunctionalLoader(param) {
    let { show, name = 'FunctionalLoader' } = param;
    const { startLoader, stopLoader } = useOverlayContext();
    useEffect(()=>{
        if (show) {
            startLoader(name);
            return ()=>{
                stopLoader(name);
            };
        }
    }, [
        show,
        name
    ]);
    return null;
}
